module.exports = __webpack_public_path__ + "static/media/mainimg-07.0401cfd2.png";